import { render, staticRenderFns } from "./RziFitoLayers.vue?vue&type=template&id=185a0178&scoped=true&"
import script from "./RziFitoLayers.vue?vue&type=script&lang=js&"
export * from "./RziFitoLayers.vue?vue&type=script&lang=js&"
import style0 from "./RziFitoLayers.vue?vue&type=style&index=0&id=185a0178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a0178",
  null
  
)

export default component.exports